import isd from '../assets/icons/isd.png'
import school from '../assets/icons/school.png'
import student from '../assets/icons/student.png'
import time from '../assets/icons/time.png'
import logo from '../assets/logo.png'
import calendar from '../assets/images/calendar.png'
// import sidebarFooterImage from '../assets/images/recovery-footer.jpg'

const appAssets = {
    common: {
        logo
    },
    icons: {
        isd,
        school,
        student,
        time,
    },
    images: {
        calendar,
        // sidebarFooterImage
    }
}

export default appAssets;